import { render, staticRenderFns } from "./EasyDental.vue?vue&type=template&id=5b5e3dc4&scoped=true"
import script from "./EasyDental.vue?vue&type=script&lang=js"
export * from "./EasyDental.vue?vue&type=script&lang=js"
import style0 from "./EasyDental.vue?vue&type=style&index=0&id=5b5e3dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5e3dc4",
  null
  
)

export default component.exports